import { createApiHooks, createActionMutation } from '../common';
import {
  getActions,
  getAction,
  getDevice,
  searchDevicesV2,
  rebootDevice,
  lockDevice,
  setDeviceServiceState,
  resetSectorGains,
  setDeviceAgcGainCaps,
  setDeviceOscMitGain,
  setDeviceAgcDuration,
  setDeviceDefaultCableLoss,
  syncDevice
} from './api';

const {
  useGetActionsQuery,
  useGetActionQuery,
  useGetDeviceQuery,
  useSearchDevicesV2Query,
  useRebootDeviceMutation,
  useLockDeviceMutation,
  useSetDeviceServiceStateMutation,
  useResetSectorGainsMutation,
  useSetDeviceAgcGainCapsMutation,
  useSetDeviceOscMitGainMutation,
  useSetDeviceAgcDurationMutation,
  useSetDeviceDefaultCableLossMutation,
  useSyncDeviceMutation
} = createApiHooks({
  name: 'cm',
  queries: {
    getActions,
    getAction,
    getDevice,
    searchDevicesV2
  },
  mutations: {
    rebootDevice,
    lockDevice,
    setDeviceServiceState,
    resetSectorGains,
    setDeviceAgcGainCaps,
    setDeviceOscMitGain,
    setDeviceAgcDuration,
    setDeviceDefaultCableLoss,
    syncDevice
  }
});

export {
  useGetActionsQuery,
  useGetActionQuery,
  useGetDeviceQuery,
  useSearchDevicesV2Query,
  useRebootDeviceMutation,
  useLockDeviceMutation,
  useSetDeviceServiceStateMutation,
  useResetSectorGainsMutation,
  useSetDeviceAgcGainCapsMutation,
  useSetDeviceOscMitGainMutation,
  useSetDeviceAgcDurationMutation,
  useSetDeviceDefaultCableLossMutation,
  useSyncDeviceMutation
};

export const useRebootActionMutation = createActionMutation(useRebootDeviceMutation, useGetActionQuery);

export const useLockActionMutation = createActionMutation(useLockDeviceMutation, useGetActionQuery);

export const useSetServiceStateMutation = createActionMutation(useSetDeviceServiceStateMutation, useGetActionQuery);

export const useResetGainsMutation = createActionMutation(useResetSectorGainsMutation, useGetActionQuery);

export const useSetAgcGainCapsActionMutation = createActionMutation(useSetDeviceAgcGainCapsMutation, useGetActionQuery);

export const useSetOscMitGainActionMutation = createActionMutation(useSetDeviceOscMitGainMutation, useGetActionQuery);

export const useSetAgcDurationActionMutation = createActionMutation(useSetDeviceAgcDurationMutation, useGetActionQuery);

export const useSetDefaultCableLossActionMutation = createActionMutation(useSetDeviceDefaultCableLossMutation, useGetActionQuery);
